import { render, staticRenderFns } from "./tagsSearchThird.vue?vue&type=template&id=4c029d5a&scoped=true"
import script from "./tagsSearchThird.vue?vue&type=script&lang=js"
export * from "./tagsSearchThird.vue?vue&type=script&lang=js"
import style0 from "./tagsSearchThird.vue?vue&type=style&index=0&id=4c029d5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c029d5a",
  null
  
)

export default component.exports